import React from "react";
import heroTree from "../../../assets/images/svg/hero-tree.svg";
import CircleCard from "./CircleCard";
import { Link } from "react-router-dom";
const Hero = () => {
  return (
    <div className="h-full bg-custom-white relative ">
      <div className="container pt-12 sm:py-8 overflow-clip max-md:px-0 relative max-sm:min-h-[640px] lg:min-h-[768px]">
        <img
          className="object-contain object-center w-full min-w-[600px] max-sm:absolute max-sm:left-1/2 max-sm:-translate-x-1/2 max-w-[980px] mx-auto"
          src={heroTree}
          alt="tree"
        />
        <Link to="/india-infra">
          <CircleCard className="top-20 left-10  sm:top-[11%] sm:left-[28%] md:top-[15%] md:left-[33%]">
            Make Way India Infra Pvt. Ltd.
          </CircleCard>
        </Link>
        <Link to="/india-corporation">
          <CircleCard className="max-sm:right-[46px] top-[142px] sm:top-[19.5%] sm:left-[60%] md:top-[20.5%] md:left-[55%]">
            Make Way India Corporation
          </CircleCard>
        </Link>
        <Link to="/india-invention">
          <CircleCard className="top-[294px] left-6 sm::top-[41.5%] sm::left-[16.5%] md:top-[41.5%] md:left-[16.5%]">
            Make Way India Invention Pvt. Ltd.
          </CircleCard>
        </Link>
        <Link to="/india-consultancy">
          <CircleCard className="max-sm:right-6 top-[330px]  sm:top-[40%] sm:left-[78%] md:top-[45%] md:left-[67%]">
            Make Way India Consultancy
          </CircleCard>{" "}
        </Link>
      </div>
      <div className="absolute bottom-0 w-full h-[105px] bg-[linear-gradient(360deg,#FFFFFF_20.48%,rgba(255,255,255,0)_100%)]"></div>
      <div className="absolute bottom-0 w-full h-20 bg-[linear-gradient(360deg,#FFFFFF 0%,rgba(255,255,255,0)_100%)]"></div>
    </div>
  );
};

export default Hero;
